module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2M20N"))).then(() => parcelRequire('f4eak'));